import { PARTNER_FEATURE_FLAGS } from '../../partner-features';
import { MenuItem } from '../types';

/**
 * "AI at ryd" sidebar section: flat links directly under the section heading (no collapsible
 * subgroup).
 *
 * Every page, Usage & Limits included, is shown only when the partner's `aiAtRydEnabled` feature
 * flag is on (Partner Administration → Partner Features); ryd-internal users always see them. A
 * partner without the flag sees no "AI at ryd" section at all (Usage & Limits was open to every
 * user until 2026-10-19; Laibing: not without the flag).
 */
const feature = {
  requiresPartnerFeature: PARTNER_FEATURE_FLAGS.AI_AT_RYD,
  partnerFeatureOpenForInternalUsers: true,
};

const link = (path: string, title: string, icon: string): MenuItem => ({
  path,
  title,
  icon: `stroke-${icon}`,
  iconf: `fill-${icon}`,
  type: 'link',
  active: false,
  ...feature,
});

export const aiAtRydSection: MenuItem[] = [
  {
    headTitle1: 'AI at ryd',
    headTitle2: 'Work with ryd through AI',
    type: 'headtitle',
  },
  link('/ai-at-ryd/overview', 'Overview', 'home'),
  link('/ai-at-ryd/capabilities', 'Tools and Examples', 'widget'),
  link('/ai-at-ryd/connect', 'Connect an Assistant', 'api-integration-widget'),
  link('/ai-at-ryd/security', 'Security and Privacy', 'secure-file'),
  link('/ai-at-ryd/usage-and-limits', 'Usage & Limits', 'charts'),
  // Only where the AI connector URL is configured for this build (code review F-51).
  // `import.meta.env` is undefined when Node scripts (the AI indexers) load the menu.
  ...(import.meta.env?.VITE_MCP_URL ? [link('/ai-at-ryd/activity', 'Activity Log', 'task')] : []),
  link('/ai-at-ryd/interface-demo', 'Interface Examples', 'webapp'),
  link('/ai-at-ryd/developers', 'Developer Guide', 'sdk'),
];
